import { render, staticRenderFns } from "./HealthCoachingStart.vue?vue&type=template&id=5edc33ae"
import script from "./HealthCoachingStart.vue?vue&type=script&lang=js"
export * from "./HealthCoachingStart.vue?vue&type=script&lang=js"
import style0 from "./HealthCoachingStart.vue?vue&type=style&index=0&id=5edc33ae&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports